<template>
  <div>
    <a-spin :spinning="loading">
      <div class="project">
        <div class="main">
          <Description
            class="description"
            title="投保人信息"
            :data-source="insureData"
          />
          <Description
            class="description"
            title="项目信息"
            :data-source="orderData"
          />
          <Description
            class="description"
            title="招标人信息"
            :data-source="projectData"
          />
        </div>
        <div class="btn">
          <a-button @click="back">
            返回上一步
          </a-button>
          <a-button
            type="primary"
            @click="apply"
          >
            确定并进入下一步
          </a-button>
        </div>
      </div>
    </a-spin>'
    <a-modal
      v-model="visible"
      :cancel-button-props="{ style: { display: 'none' } }"
      @ok="handleOk"
      centered
      :mask-closable="false"
      :keyboard="false"
      ok-text="确定"
    >
      <p>用户未登录，请重新登录。</p>
    </a-modal>
  </div>
</template>

<script>
import { dateFormat, dateFormatDay } from '@/utils/format.js';
import Description from '@/components/Description';
import { applyDetail, apply } from '@/api/insure/guarantee.js';
import { Modal } from 'ant-design-vue';
export default {
  name: 'ConInsure',
  components: {
    Description,
  },
  data() {
    return {
      visible: false,
      loading: false,
      sectionId: '',
      insureData: {
        companyName: '',
        creditCode: '',
      },
      orderData: {
        projectName: '',
        sectionName: '',
        sectionCode: '',
        limit: '',
        bidOpenTime: '',
        payOpenTime: '',
      },
      projectData: {
        tenderName: '',
        tenderCode: '',
        tenderAddress: '',
      },
    };
  },
  mounted() {
    this.fetch();
  },
  methods: {
    handleOk() {
      this.$router.push({ name: 'login' });
    },
    apply() {
      // const { info: { certifications, busLicenseStart }, bidStatus } = this.$store.state;
      // if (certifications === null) {
      //   this.$message.warning('该用户企业资料未完善，请先完善！');
      //   return;
      // }
      // if (busLicenseStart === null && bidStatus === 1) {
      //   const _this = this;
      //   Modal.confirm({
      //     content: '该用户未完善营业执照有效期，点击完善！',
      //     onOk() {
      //       return new Promise(resolve => {
      //         setTimeout(resolve, 1000);
      //       }).then(res => {
      //         res;
      //         _this.$router.push({ name: 'entCertForm' });
      //       }).catch(() => console.log('Oops errors!'));
      //     },
      //     okText: '去完善',
      //     cancelText: '取消',
      //     onCancel() {
      //       self.destroy;
      //     },
      //   });
      //   return;
      // }
      apply({ sectionId: this.sectionId }).then(res => {
        if (res.data.status === 'FAIL') {
          this.$message.warning(res.data.errorMsg);
        } else {
          const insureUrl = `${process.env.VUE_APP_INSURE_ZTB_HREF}/#/tenderNotice?orderNo=${res.data.data}`;
          window.open(insureUrl);
        }
      });
    },
    back() {
      // this.$parent.changeActive(0);
      this.$router.go(-1);
    },
    fetch() {
      this.loading = true;
      this.sectionId = JSON.parse(sessionStorage.getItem('projectSectionId'));
      applyDetail({ sectionId: this.sectionId }).then(res => {
        if (res.data.errorMsg === '用户未登录') {
          this.visible = true;
        } else if (res.data.errorMsg === '系统异常') {
          this.$message.warning(res.data.errorMsg);
        } else {
          const data = Object.assign([], res.data.data);
          if (data.certification) {
            Object.keys(data.certification).forEach(item => {
              Object.keys(this.insureData).forEach(it => {
                if (it === item) {
                  this.insureData[it] = data.certification[item];
                }
              });
            });
          } else {
            this.$router.push({ name: 'entCertForm' });
          }
          Object.keys(data).forEach(item => {
            Object.keys(this.orderData).forEach(it => {
              if (it === item) {
                this.orderData[it] = data[item];
              }
            });
            if (this.orderData.bidOpenTime) {
              this.orderData.bidOpenTime = dateFormat(
                this.orderData.bidOpenTime
              );
              this.orderData.payOpenTime =
                dateFormatDay(this.orderData.bidOpenTime) + ' 00:00:00';
            }
            Object.keys(this.projectData).forEach(it => {
              if (it === item) {
                if (data[item]) {
                  this.projectData[it] = data[item];
                } else {
                  delete this.projectData[it];
                }
                this.projectData = Object.assign({}, this.projectData);
              }
            });
          });
          this.loading = false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.project {
  .plate {
    margin-top: 30px;
    .subtitle {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      /deep/ .anticon {
        margin-right: 5px;
      }
    }
  }
  .main {
    margin: 50px 0;
    .description {
      margin-bottom: 30px;
    }
  }
  .btn {
    text-align: center;
    padding-top: 40px;
    border-top: 1px solid #ebf2f7;
    /deep/ .ant-btn {
      width: 200px;
      height: 44px;
      border-radius: 4px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      margin: 0 20px;
      &:nth-child(1) {
        border: 1px solid #007ce2;
        color: #007ce2;
      }
    }
  }
}
</style>
